import type { RouteLocationNamedRaw, RouteLocationRaw } from 'vue-router';
import { inject } from 'vue';

export default function useParentRoute() {
    const parentRoutePrefix = inject<string>('parentRoutePrefix', '');
    const parentRouteParams = inject<{ [key: string]: string }>('parentRouteParams', {});

    return (route: RouteLocationNamedRaw, targetParentPrefix = '') => {
        const routePrefix = targetParentPrefix || parentRoutePrefix;
        const newRoute = { ...route };
        newRoute.name = `${routePrefix}${String(route.name)}`;
        newRoute.params = {
            ...route.params,
            ...parentRouteParams,
        };

        return newRoute as RouteLocationRaw;
    };
}
